var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 0.25C4.38544 0.25 0.916687 3.75 0.916687 8C0.916687 12.2812 4.38544 15.75 8.66669 15.75C12.9167 15.75 16.4167 12.2812 16.4167 8C16.4167 3.75 12.9167 0.25 8.66669 0.25ZM8.66669 3.6875C9.38544 3.6875 9.97919 4.28125 9.97919 5C9.97919 5.75 9.38544 6.3125 8.66669 6.3125C7.91669 6.3125 7.35419 5.75 7.35419 5C7.35419 4.28125 7.91669 3.6875 8.66669 3.6875ZM10.4167 11.625C10.4167 11.8438 10.2292 12 10.0417 12H7.29169C7.07294 12 6.91669 11.8438 6.91669 11.625V10.875C6.91669 10.6875 7.07294 10.5 7.29169 10.5H7.66669V8.5H7.29169C7.07294 8.5 6.91669 8.34375 6.91669 8.125V7.375C6.91669 7.1875 7.07294 7 7.29169 7H9.29169C9.47919 7 9.66669 7.1875 9.66669 7.375V10.5H10.0417C10.2292 10.5 10.4167 10.6875 10.4167 10.875V11.625Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9555bc9d8d7c80556cec4f5608983531.svg";
export { ForwardRef as ReactComponent };